import axios from './HTTP'

export default {
  getList (params) {
    return axios
      .get('/api/location_shifts.json', { params: params })
      .then(response => response.data)
  },
}
